export const dynamicComponentsMixin = {
  components: {
    AsideInfoBlock: () => import("@/components/blocks/AsideInfoBlock"),
    PageTitle: () => import("@/components/blocks/PageTitle"),
    PageTabsBlock: () => import("@/components/blocks/PageTabsBlock"),
    VideoCarousel: () => import("@/components/blocks/VideoCarousel"),
    QueryForm: () => import("@/components/pl-form-blocks/QueryForm"),
  }
}